import classNames from "classnames";
import { FC } from "react";
import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import orderAddSummaryRouteHelper from "./order-add-summary-route.helper";
import OrderAddSummaryRouteWaypoint from "./types/order-add-summary-route-waypoint";

type OrderAddSummaryRouteProps = {
  waypoints: OrderAddSummaryRouteWaypoint[];
  selectedPassengerUuid: string | null;
};

const OrderAddSummaryRouteComponent: FC<OrderAddSummaryRouteProps> = (
  props,
) => {
  const translations =
    orderTranslationsHelper.getAddTranslations().summary.routes;

  return (
    <div className="order_add_summary_route" data-test-id="summary-route">
      <div className="order_add_summary_route_waypoint_list">
        <div className="order_add_summary_route_waypoint_list__header">
          <div
            className="order_add_summary_route_waypoint_list__heading place"
            title={translations.placeHeaderTitle}
          >
            {translations.placeHeaderLabel}
          </div>
          <div
            className="order_add_summary_route_waypoint_list__heading ordered_date"
            title={translations.orderedDateHeaderTitle}
          >
            {translations.orderedDateHeaderLabel}
          </div>
          <div
            className="order_add_summary_route_waypoint_list__heading estimated_date"
            title={translations.estimatedDateHeaderTitle}
          >
            {translations.estimatedDateHeaderLabel}
          </div>
          <div
            className="order_add_summary_route_waypoint_list__heading halting_time"
            title={translations.haltingTimeHeaderTitle}
          >
            {translations.haltingTimeHeaderLabel}
          </div>
          <div
            className="order_add_summary_route_waypoint_list__heading distance"
            title={translations.distanceHeaderTitle}
          >
            {translations.distanceHeaderLabel}
          </div>
        </div>
        {props.waypoints.map((waypoint, index) => {
          const isHighlightedAsPassengerOnboardPlace =
            props.selectedPassengerUuid &&
            waypoint.onboardingPassengers.find(
              (onboardingPassenger) =>
                onboardingPassenger.uuid === props.selectedPassengerUuid,
            );

          const isHighlightedAsPassengerOutboardPlace =
            props.selectedPassengerUuid &&
            waypoint.outboardingPassengers.find(
              (outboardingPassenger) =>
                outboardingPassenger.uuid === props.selectedPassengerUuid,
            );

          const isFaded =
            props.selectedPassengerUuid &&
            !isHighlightedAsPassengerOnboardPlace &&
            !isHighlightedAsPassengerOutboardPlace;

          return (
            <div
              className={classNames(
                "order_add_summary_route_waypoint_list__row",
                isHighlightedAsPassengerOnboardPlace && "onboard_highlight",
                isHighlightedAsPassengerOutboardPlace && "outboard_highlight",
                isFaded && "faded",
              )}
              key={`order-add-summary-waypoint-index-${index}`}
              data-test-id={`summary-route-waypoint-index-${index}`}
            >
              <div
                className="order_add_summary_route_waypoint_list__row_cell place"
                title={orderAddSummaryRouteHelper.getPlaceTitle(waypoint.place)}
              >
                <div className="index">{waypoint.stageNo}</div>
                <div className="dot_container">
                  <div
                    className={classNames(
                      "dot",
                      orderAddSummaryRouteHelper.generateWaypointDotClassname(
                        waypoint,
                      ),
                    )}
                  />
                </div>
                <div className="place_name">
                  {orderAddSummaryRouteHelper.getPlaceLabel(waypoint.place)}
                </div>
              </div>
              <div
                title={orderAddSummaryRouteHelper.getOrderedDateTitle(
                  waypoint.orderedDate,
                )}
                className="order_add_summary_route_waypoint_list__row_cell ordered_date"
              >
                {orderAddSummaryRouteHelper.getOrderedDateLabel(
                  waypoint.orderedDate,
                )}
              </div>
              <div
                title={orderAddSummaryRouteHelper.getEstimatedDateTitle(
                  waypoint.estimatedDate,
                )}
                className="order_add_summary_route_waypoint_list__row_cell estimated_date"
              >
                {orderAddSummaryRouteHelper.getEstimatedDateLabel(
                  waypoint.estimatedDate,
                )}
              </div>
              <div className="order_add_summary_route_waypoint_list__row_cell halting_time">
                {orderAddSummaryRouteHelper.getHaltingTime(
                  waypoint.haltingTime,
                )}
              </div>
              <div className="order_add_summary_route_waypoint_list__row_cell distance">
                {orderAddSummaryRouteHelper.getDistanceLabel(waypoint.distance)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderAddSummaryRouteComponent;
